import { connect } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { Redirect, Route, Router } from 'react-router-dom'
import React, { useEffect } from 'react'

import 'react-animated-router/animate.css'

import { history } from './services'
import { ProtectedRoute } from './components/ProtectedRoute/ProtectedRoute'
import { saveWechatJsConfig } from './actions'
import AddressFormPage from './pages/AddressForm/AddressForm'
import AFDIApplication from './pages/AFDI/AFDIApplication'
import AFdiTDetail from './pages/AFDIT/AppDetail'
import AFDITList from './pages/AFDIT/AppList'
import AgentElearning from './pages/AgentElearning/AgentElearning'
import AppContainer from './AppContainer'
import AuthorizePage from './pages/Authorization/Authorize'
import BasicMermaidApplication from './pages/BasicMermaid/BasicMermaidApplication'
import BasicMermaidTDetail from './pages/BasicMermaidT/AppDetail'
import BasicMermaidTList from './pages/BasicMermaidT/AppList'
import BooksCheckout from './pages/PriceList/BooksCheckout'
import BooksCheckoutResult from './pages/PriceList/BooksCheckoutResult'
import BuyCards from './pages/BuyCards/BuyCards'
import BuyCardsPreview from './pages/BuyCards/BuyCardsPreview'
import CampaignPage from './pages/Campaign/Campaign'
import CartPage from './pages/Cart/Cart'
import CdApplication from './pages/CdApplication/CdApplication'
import CdAppListPage from './pages/CdApplication/CdAppList'
import CdSiAppDetail from './pages/CdApplication/CdAppDetail'
import CertDetailPage from './pages/CertDetail/CertDetailPage'
import Checkout from './pages/AgentElearning/Checkout'
import ColorCorrect from './pages/ColorCorrect/ColorCorrect'
import ConfirmAppsPage from './pages/DmForInstructor/ConfirmAppsPage'
import CreditCard from './pages/CreditCard/CreditCard'
import CreditResult from './pages/CreditCard/CreditResult'
import DMForInstructorPage from './pages/DmForInstructor/DmForInstructor'
import DMFormPage from './pages/DiveMasterForm/DMFormPage'
import DMFormResultPage from './pages/DiveMasterForm/DMFormResultPage'
import EcardsPage from './pages/EcardsPage/EcardsPage'
import EFRIApplication from './pages/EFRI/EFRIApplication'
import EFRIAppList from './pages/EFRIT/EFRIAppList'
import EFRITDetail from './pages/EFRIT/EFRITDetail'
import FDIApplication from './pages/FDI/FDIApplication'
import FdiTDetail from './pages/FDIT/AppDetail'
import FDITList from './pages/FDIT/AppList'
import IeExamAttempts from './pages/IeExamAttempts/IeExamAttempts'
import IeResit from './pages/IeResit/IeResit'
import MermaidAppPage from './pages/MermaidApp/MermaidAppPage'
import MermaidTDetail from './pages/MermaidT/AppDetail'
import MermaidTList from './pages/MermaidT/AppList'
import MFDIApplication from './pages/MFDI/MFDIApplication'
import MFdiTDetail from './pages/MFDIT/AppDetail'
import MFDITList from './pages/MFDIT/AppList'
import MyProfile from './pages/MyProfile/MyProfile'
import NewAppPage from './pages/DiveMasterForm/NewAppPage'
import NewYearCampaignPage from './pages/NewYearCampaign/Campaign'
import NewYearCampaignPostPage from './pages/NewYearCampaign/CampaignHomePage'
import OwsiApplication from './pages/OwsiApplication/OwsiApplication'
import OwsiCdAppDetailPage from './pages/OwsiCdApps/OwsiCdAppDetail'
import OwsiCdAppsPage from './pages/OwsiCdApps/OwsiCdApps'
import PicCollectionPage from './pages/PicCollection/PicCollectionPage'
import PriceListPage from './pages/PriceList/PriceListPage'
import PublicWelfareCert from './pages/CardImgUpload/PublicWelfareCert'
import RenewPage from './pages/Renew/Renew'

import ResultPage from './components/common/ResultPage'
import SetProfilePage from './pages/SetProfile/SetProfile'
import SpecialtyAppDetail from './pages/SpecialtyInstructor/SpecialtyAppDetail'
import SpecialtyAppListPage from './pages/SpecialtyInstructor/SpecialtyAppList'
import SpecialtyInstructor from './pages/SpecialtyInstructor/SpecialtyInstructor'
import Torcher from './pages/Torcher/cert'
import RegulatorCouponPage from './pages/RegulatorCoupon/RegulatorCoupon'
import DecodeQrcodePage from './pages/RegulatorCoupon/DecodeQrcode'
import PocketsApplication from './pages/PocketsApplication/PocketsApplication'
import PocketsAppsList from './pages/PocketsApplication/PocketsAppsList'
import PocketsApplicationResult from './pages/PocketsApplication/PocketsApplicationResult'
import StoreApplicationPage from './pages/StoreApplication/StoreApplication'
import StoreAppsList from './pages/StoreApplication/StoreAppsList'
import InvoiceFormPage from './pages/Invoice/InvoiceFormPage'
import AnniversaryAwards from './pages/Awards/Anniversary'
import EliteInstructorAwards from './pages/Awards/EliteInstructor'

import './App.css'
import './assets/css/common.css'

import CourseInfoRoutes from './routes/CourseInfoRoutes'
import UserAdminRoutes from './routes/UserAdminRoutes'
import PadiAdminRoutes from './routes/PadiAdminRoutes'
import ScubaOW from './routes/ScubaOWRoutes'
import ProcheckRoutes from './routes/ProcheckRoutes'
import IssueCertsNewPage from './pages/IssueCerts/new'
import IssueCertsListPage from './pages/IssueCerts/list'
import IssueCertsDetailPage from './pages/IssueCerts/detail'
import { IntlWrapper } from './components/IntlWrapper'

import EmailLoginPage from './pages/emailLogin/emailLogin'
import RegisterPage from './pages/Register/register'
import Success from './pages/RegistrationResult/Success'
import Failure from './pages/RegistrationResult/Failure'
import WechatAuth from './WechatAuth'
import EFRPublicInstructorAppPage from './pages/MemberApplications/efrpi'
import MergeFeedbackPage from './pages/EcardsPage/MergeFeedbackPage'
import ResetPwd from './pages/emailLogin/resetPwd'
import FindResult from './pages/FindAccount/FindResult'
import PersonalInfo from './pages/FindAccount/PersonalInfo'
import SubmitResult from './pages/FindAccount/SubmitResult'
import AdsEditorPage from './pages/Admin/AdsEditor'
import MemberZone from './pages/MyProfile/MemberZone'
import ApplicationSubmitResult from './pages/ApplicationSubmitResult/ApplicationSubmitResult'
import PaymentResultPage from './pages/ApplicationSubmitResult/PaymentResultPage'
import ClubEcards from './pages/ClubEcards/ClubEcards'
import PicOrderList from './pages/CoursePicOrder/OrderListPage'
import PicOrderDetail from './pages/CoursePicOrder/OrderDetailPage'
import UnconventionalOrderList from './pages/UnconventionalOrder/OrderListPage'
import UnconventionalOrderDetail from './pages/UnconventionalOrder/OrderDetailPage'
import RenewCouponsListPage from './pages/RenewCouponsList/'
import MobileSelectionPage from './pages/VerifyMobile/MobileSelectionPage'
import ClubVipChangeEcards from './pages/ClubVipChangeEcards/ClubVipChangeEcards'
import IEStatement from './pages/IEStatement/IEStatement'
import IeOrientation from './pages/IEStatement/IeOrientation'
import IeStatementList from './pages/IEStatement/IeStatementList'
import AutoRenewPage from './pages/AutoRenew/AutoRenewal'
import GlobalEcards from './pages/GlobalEacrds/GlobalEcards'
import UserAgreement from './pages/UserAgreement/UserAgreement'
import ClubEcardsEquity from './pages/ClubEcardsEquity/ClubEcardsEquity'
import VipChangeEcardsRotator from './pages/ClubVipChangeEcards/VipChangeEcardsRotator'
import AutoRenewStorePage from './pages/AutoRenewStore/AutoRenewalStore'
import CDRenewalPage from './pages/CDRenewal/CDRenewal'
import MermaidUpload from './pages/MermaidUpload/MermaidUpload'
import RenewalLanding from './pages/RenewalLanding/RenewalLanding'
import RenewalLandingStore from './pages/RenewalLandingStore/RenewalLandingStore'
import AutoRenewSuccess from './pages/AutoRenew/AutoRenewSuccess'
import MyPurchasesPage from './pages/MyPurchases/MyPurchasesPage'
import DsdWeWorkMobilePage from './pages/DSDMobile/DsdWeWorkMobile'

function App(props) {
  useEffect(() => {
    // 阻止微信字体缩放
    if (typeof window.top.WeixinJSBridge !== 'undefined') {
      window.top.WeixinJSBridge.invoke('setFontSizeCallback', {
        fontSize: 0,
      })
    }

    //android禁止微信浏览器调整字体大小
    if (typeof window.top.WeixinJSBridge == 'object' && typeof window.top.WeixinJSBridge.invoke == 'function') {
      handleFontSize()
    } else {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', handleFontSize, false)
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', handleFontSize)
        document.attachEvent('onWeixinJSBridgeReady', handleFontSize)
      }
    }

    // 添加viewport meta标签（动态添加备用方案）
    const meta = document.createElement('meta')
    meta.name = 'viewport'
    meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
    document.getElementsByTagName('head')[0].appendChild(meta)

    return () => {
      // 清理
      const metas = document.getElementsByTagName('meta')
      for (let i = 0; i < metas.length; i++) {
        if (metas[i].name === 'viewport') {
          metas[i].parentNode.removeChild(metas[i])
        }
      }
    }
  }, [])

  function handleFontSize() {
    // 设置网页字体为默认大小
    window.top.WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 })
    // 重写设置网页字体大小的事件
    window.top.WeixinJSBridge.on('menu:setfont', function () {
      window.top.WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 })
    })
  }

  return (
    <WechatAuth>
      <IntlWrapper>
        <ConnectedRouter history={history}>
          <Router history={history}>
            <Route exact path="/authorize">
              <AuthorizePage />
            </Route>
            <Route
              path="/lx"
              /* 纯跳转路由：必须在 render 里而不是 component —— component 要求传「组件类型」，
                 传内联函数会让 react-router 每帧重建组件、反复卸载重挂（5.2+ 会告警） */
              render={() => {
                window.location.replace('https://assets.padi.com.cn/lx/index.html')
                return null
              }}
            />
            <Route path="/pw_cert">
              <Torcher />
            </Route>
            <Route path="/color_correct" component={ColorCorrect} />
            <div className="limited-width">
              {/* <Splash /> */}
              <Route path="/emailLogin" component={EmailLoginPage} />
              <Route path="/weWorkBind" component={DsdWeWorkMobilePage} />
              <Route path="/register" component={RegisterPage} />
              <Route path="/registrationSuccess" component={Success} />
              <Route path="/registrationFailure" component={Failure} />
              <Route path="/reset_pwd" component={ResetPwd} />
              <Route path="/find_account/result" component={FindResult} />
              <Route path="/find_account/user_info" component={PersonalInfo} />
              <Route path="/find_account/submit_result" component={SubmitResult} />
              <Route path="/mobile_selection" component={MobileSelectionPage} />

              <Route path="/submit_success" component={ResultPage} />
              <Route exact path="/">
                <Redirect to="/certs" />
              </Route>
              <AppContainer>
                <Route path="/resources_collection" component={PicCollectionPage} />
                <CourseInfoRoutes />
                <UserAdminRoutes />
                <ScubaOW />
                <ProcheckRoutes />
                <ProtectedRoute path="/members" component={MemberZone} />
                <ProtectedRoute path="/buy_cards" component={BuyCards} />
                <ProtectedRoute path="/myProfile" component={MyProfile} />
                <ProtectedRoute path="/cert/:type/:certId" component={CertDetailPage} />
                <ProtectedRoute path="/campaign" component={CampaignPage} />
                <ProtectedRoute path="/certs" component={EcardsPage} />
                <ProtectedRoute path="/ecards" component={EcardsPage} />

                {/* without tabbar */}
                <ProtectedRoute path="/newYearCampaign" component={NewYearCampaignPage} />
                <ProtectedRoute path="/newYearCampaignPost" component={NewYearCampaignPostPage} />

                <ProtectedRoute path="/addressForm" component={AddressFormPage} />
                <ProtectedRoute path="/cart" component={CartPage} />
                <ProtectedRoute path="/renew/:type" component={RenewPage} />
                <ProtectedRoute path="/dmForm" component={DMFormPage} />
                <ProtectedRoute path="/dmFormResult" component={DMFormResultPage} />
                <ProtectedRoute path="/bookSaleList" component={PriceListPage} />
                <ProtectedRoute path="/books_checkout" component={BooksCheckout} />

                <ProtectedRoute path="/dmForInstructor" component={DMForInstructorPage} />
                <ProtectedRoute path="/confirmApps" component={ConfirmAppsPage} />
                <ProtectedRoute path="/new_app" component={NewAppPage} />
                <ProtectedRoute path="/specialtyApp" component={SpecialtyInstructor} />
                <ProtectedRoute path="/siAppList" component={SpecialtyAppListPage} />
                <ProtectedRoute path="/siAppDetail" component={SpecialtyAppDetail} />
                <ProtectedRoute path="/cdAppForm" component={CdApplication} />
                <ProtectedRoute path="/cdAppList" component={CdAppListPage} />
                <ProtectedRoute path="/cdAppDetail" component={CdSiAppDetail} />
                <ProtectedRoute path="/owsi_app" component={OwsiApplication} />
                <ProtectedRoute path="/owsi_cd_apps" component={OwsiCdAppsPage} />
                <ProtectedRoute path="/ie_resit" component={IeResit} />
                <ProtectedRoute path="/set_profile" component={SetProfilePage} />
                <ProtectedRoute path="/owsi_cd_app_detail" component={OwsiCdAppDetailPage} />
                <ProtectedRoute path="/ie_exam_attempts" component={IeExamAttempts} />
                <ProtectedRoute path="/credit_card" component={CreditCard} />
                <ProtectedRoute path="/pay_success" component={CreditResult} />
                <ProtectedRoute path="/books_submit_success" component={BooksCheckoutResult} />
                <ProtectedRoute path="/agent_elearning" component={AgentElearning} />
                <ProtectedRoute path="/efri_app" component={EFRIApplication} />
                <ProtectedRoute path="/efrt_list" component={EFRIAppList} />
                <ProtectedRoute path="/efrt_detail" component={EFRITDetail} />
                <ProtectedRoute path="/basic_mermaid_app" component={BasicMermaidApplication} />
                <ProtectedRoute path="/basic_mermaid_app_list" component={BasicMermaidTList} />
                <ProtectedRoute path="/basic_mermaid_app_detail" component={BasicMermaidTDetail} />
                <ProtectedRoute path="/mermaidi_app" component={MermaidAppPage} />
                <ProtectedRoute path="/mermaid_app_list" component={MermaidTList} />
                <ProtectedRoute path="/mermaid_app_detail" component={MermaidTDetail} />
                <ProtectedRoute path="/fdi_app" component={FDIApplication} />
                <ProtectedRoute path="/fdi_app_list" component={FDITList} />
                <ProtectedRoute path="/fdi_app_detail" component={FdiTDetail} />
                <ProtectedRoute path="/afdi_app" component={AFDIApplication} />
                <ProtectedRoute path="/afdi_app_list" component={AFDITList} />
                <ProtectedRoute path="/afdi_app_detail" component={AFdiTDetail} />
                <ProtectedRoute path="/mfdi_app" component={MFDIApplication} />
                <ProtectedRoute path="/mfdi_app_list" component={MFDITList} />
                <ProtectedRoute path="/mfdi_app_detail" component={MFdiTDetail} />
                <ProtectedRoute path="/public_welfare_cert" component={PublicWelfareCert} />
                <ProtectedRoute path="/agent_elearning_checkout" component={Checkout} />
                <ProtectedRoute path="/efr_public/app" component={EFRPublicInstructorAppPage} />
                <ProtectedRoute path={'/issue_certs/new'} component={IssueCertsNewPage} />
                <ProtectedRoute path={'/issue_certs/list'} component={IssueCertsListPage} />
                <ProtectedRoute path={'/issue_certs/detail'} component={IssueCertsDetailPage} />
                <ProtectedRoute path={'/regulator_coupon'} component={RegulatorCouponPage} />
                <Route path="/decode_qrcode" component={DecodeQrcodePage} />
                <ProtectedRoute path="/merge_certs_success" component={MergeFeedbackPage} />
                <ProtectedRoute path="/pockets_apps" component={PocketsApplication} />
                <ProtectedRoute path="/pockets_apps_list" component={PocketsAppsList} />
                <ProtectedRoute path="/pockets_apps_result" component={PocketsApplicationResult} />
                <ProtectedRoute path="/ads_editor" component={AdsEditorPage} />
                <ProtectedRoute path="/admin/ads_editor" component={AdsEditorPage} />
                <ProtectedRoute path="/store_apps" component={StoreApplicationPage} />
                <ProtectedRoute path="/store_apps_list" component={StoreAppsList} />
                <ProtectedRoute path="/invoice_form" component={InvoiceFormPage} />
                <ProtectedRoute path="/anniversary" component={AnniversaryAwards} />
                <ProtectedRoute path="/elite_instructor" component={EliteInstructorAwards} />
                <ProtectedRoute path="/application_submit_success" component={ApplicationSubmitResult} />
                <ProtectedRoute path="/paymentSuccess" component={PaymentResultPage} />
                <ProtectedRoute path="/club_ecards" component={ClubEcards} />
                <ProtectedRoute path="/pic_order_list" component={PicOrderList} />
                <ProtectedRoute path="/pic_order_detail" component={PicOrderDetail} />
                <ProtectedRoute path="/unconventional_order_list" component={UnconventionalOrderList} />
                <ProtectedRoute path="/unconventional_order_detail" component={UnconventionalOrderDetail} />
                <ProtectedRoute path="/renew_coupons_list" component={RenewCouponsListPage} />
                <ProtectedRoute path="/vip_change_ecards" component={ClubVipChangeEcards} />
                <ProtectedRoute path="/ie_statement" component={IEStatement} />
                <ProtectedRoute path="/ie_orientation" component={IeOrientation} />
                <ProtectedRoute path="/ie_status" component={IeStatementList} />
                <Route path="/buy_cards_preview" component={BuyCardsPreview} />
                <Route path="/china_ecards" component={GlobalEcards} />
                <ProtectedRoute path="/user_agreements" component={UserAgreement} />
                <Route path="/club_ecards_equity" component={ClubEcardsEquity} />
                <Route path="/vip_change_ecards_rotator" component={VipChangeEcardsRotator} />
                <ProtectedRoute path="/auto_renew" component={AutoRenewPage} />
                <ProtectedRoute path="/auto_renew_store" component={AutoRenewStorePage} />
                <ProtectedRoute path="/cd_renewal" component={CDRenewalPage} />
                <ProtectedRoute path="/mermaid/upload" component={MermaidUpload} />
                <ProtectedRoute path="/renewal_options" component={RenewalLanding} />
                <ProtectedRoute path="/renewal_options_store" component={RenewalLandingStore} />
                <ProtectedRoute path="/renewal_success" component={AutoRenewSuccess} />
                <ProtectedRoute path="/my_purchases" component={MyPurchasesPage} />
              </AppContainer>
            </div>
            <PadiAdminRoutes />
          </Router>
        </ConnectedRouter>
      </IntlWrapper>
    </WechatAuth>
  )
}

export default connect(null, { saveWechatJsConfig })(App)
